<template>
  <Modal v-model="visible" width="920" title="新建推广计划" :transfer="false" :mask-closable="false" @on-visible-change="bindGetData">
    <Form :label-width="180" :style="{ maxHeight: '560px', overflowY: 'auto' }">
      <FormItem label="投放账号">
        <el-select v-model="campaign.account_ids" multiple filterable placeholder="请选择投放账号" style="width: 520px">
          <el-option v-for="item in data" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </FormItem>
      <FormItem label="推广目标">
        <RadioGroup v-model="campaign.subject" type="button" @on-change="changeSubject">
          <Radio :label="1">网站链接</Radio>
          <Radio :label="2">应用下载(iOS)</Radio>
          <Radio :label="3" disabled>应用下载(Andriod)</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="推广游戏" v-if="campaign.subject !== 1">
        <auto-complete v-model="campaign.gameId" :data="platformGameData" :width="520" placeholder="请选择游戏" @on-select="handleGame" />
      </FormItem>
      <FormItem label="应用名称" v-if="campaign.subject !== 1">
        <input-len v-model="campaign.appName" placeholder="最大20个字符，1个中文等于2个字符" :max="20" :width="520" />
      </FormItem>
      <FormItem label="推广的URL" v-if="campaign.subject !== 1">
        <Input v-model="campaign.appUrl" placeholder="请输入推广应用链接" style="width: 520px" readonly />
      </FormItem>
      <FormItem label="推广计划预算">
        <RadioGroup v-model="budgetMode" type="button" @on-change="changBudget">
          <Radio :label="0">不限</Radio>
          <Radio :label="1">指定预算</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="" v-if="budgetMode">
        <input-number-plus
          v-model="campaign.budget"
          :max="7"
          :min="50"
          :step="0.1"
          :precision="2"
          :width="520"
          placeholder="请输入50-9,999,999.99数值"
        />
        <span style="padding: 0 6px"> 元 </span>
      </FormItem>
      <FormItem label="推广日期">
        <RadioGroup v-model="timeType" type="button" @on-change="changeTime">
          <Radio label="NONE">不限</Radio>
          <Radio label="CUSTOM">指定日期</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-if="timeType === 'CUSTOM'">
        <DatePicker
          type="date"
          :value="campaign.starttime"
          placeholder="请选择开始日期"
          style="width: 160px"
          :options="{ disabledDate: startOption }"
          @on-change="changeStartTime"
        />
        <span class="m-date-split">~</span>
        <DatePicker
          type="date"
          :value="campaign.endtime"
          placeholder="请选择结束日期"
          style="width: 160px"
          :options="{ disabledDate: endOption }"
          @on-change="changeEndTime"
        />
      </FormItem>
      <FormItem label="推广时段">
        <RadioGroup v-model="timeRange" type="button" @on-change="radioChange('weektimeData')">
          <Radio label="NONE">不限</Radio>
          <Radio label="RANGE">指定时段</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-if="timeRange === 'RANGE'">
        <drag-weektime v-model="mult_timeRange" :data="weektimeData" :colspan="1" @on-clear="clearWeektime" />
      </FormItem>
      <FormItem label="投放速度">
        <RadioGroup v-model="campaign.bgtctltype" type="button">
          <Radio :label="1">标准</Radio>
          <Radio :label="0">平衡投放</Radio>
          <Radio :label="2">展现优先</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="批量建立">
        <i-switch v-model="batch" @on-change="changeBatch" />
      </FormItem>
      <FormItem v-if="batch" label="推广计划数量">
        <input-range v-model="campaign.range" :min="1" :max="999" :step="100" />
      </FormItem>
      <FormItem label="推广计划名称">
        <input-len v-model="campaign.campaignFeedName" placeholder="最大100个字符，1个中文等于2个字符" :max="100" width="520" />
      </FormItem>
      <FormItem label="推广计划状态">
        <i-switch v-model="campaign.pause" size="large">
          <span slot="open">开启</span>
          <span slot="close">关闭</span>
        </i-switch>
      </FormItem>
    </Form>

    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" :loading="loading" @click="asyncSelect">
        <span v-if="!loading">确定</span>
        <span v-else>提交中...</span>
      </Button>
    </template>
  </Modal>
</template>
<script>
import moment from 'moment'
import { isArray, isEmpty, getTime, formatDate, splicing, deepCopy, getByteLen, clearTagOfData } from '@/common/js/utils'
import weektimeData from '@/data/baidu/weektime_data'

// 引用组件
import DragWeektime from '@/components/drag/drag-weektime.vue'
import InputLen from '@/components/input/input-len'
import InputRange from '@/components/input/input-number-range'
import InputNumberPlus from '@/components/input/input-number-plus'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'

export default {
  name: 'AddGroup',
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    gameData: {
      type: Array
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$set('input', val)
      }
    },
    startOption() {
      return (date) => {
        return date && date.valueOf() < Date.now() - 86400000
      }
    },
    endOption() {
      return (date) => {
        return date && date.valueOf() < getTime(this.campaign.starttime)
      }
    },
    mult_timeRange() {
      return this.weektimeData.map((item) => {
        return {
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        }
      })
    },
    platformGameData() {
      let platform
      if (this.campaign.subject === 1) platform = 0
      else if (this.campaign.subject === 2) platform = 2
      else if (this.campaign.subject === 3) platform = 1
      return this.gameData.filter((ret) => (platform ? ret.ch_platform_id === platform : !platform))
    }
  },
  components: {
    InputLen,
    InputRange,
    InputNumberPlus,
    AutoComplete,
    DragWeektime
  },
  data() {
    return {
      batch: null, // 是否批量
      budgetMode: 0,
      timeType: 'NONE',
      timeRange: 'NONE',
      weektimeData: deepCopy(weektimeData), // 时间区域
      campaign: {
        account_ids: [],
        subject: 2,
        campaignType: 1,
        campaignFeedName: '',
        bgtctltype: 1, // 标准
        bstype: 1,
        budget: 0,
        gameId: '', // !1
        appName: '',
        appUrl: '',
        pause: false,
        range: ['', '']
      }
    }
  },
  methods: {
    changeSubject(val) {
      let gameId, appName, appUrl
      if (val > 1) {
        gameId = ''
        appName = ''
        appUrl = ''
      }
      this.$set(this.campaign, 'gameId', gameId)
      this.$set(this.campaign, 'appName', appName)
      this.$set(this.campaign, 'appUrl', appUrl)
    },
    // 处理7*24位值
    getWeektime(val) {
      const data = []
      for (const item of val) {
        const keys = splicing(item.child)
        if (keys) {
          if (keys.indexOf('、') > 0) {
            const some = keys.split('、')
            some.map((ret) => {
              const h = ret.indexOf('~') > 0 && ret.split('~')
              data.push({ weekDay: item.row + 1, startHour: h && parseInt(h[0]), endHour: h && parseInt(h[1]) })
            })
          } else if (keys.indexOf('~') > 0) {
            const h = keys.split('~')
            data.push({ weekDay: item.row + 1, startHour: h && parseInt(h[0]), endHour: h && parseInt(h[1]) })
          }
        }
      }
      return data
    },
    radioChange(defautData) {
      clearTagOfData(this[defautData], this)
    },
    clearWeektime() {
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    changeTime(val) {
      let starttime
      let endtime
      if (val === 'CUSTOM') {
        starttime = moment().format('YYYY-MM-DD')
        endtime = moment().add(7, 'days').format('YYYY-MM-DD')
      }
      this.$set(this.campaign, 'starttime', starttime)
      this.$set(this.campaign, 'endtime', endtime)
    },
    changeStartTime(val) {
      const start = getTime(val)
      const end = getTime(this.campaign.endtime)
      if (end < start) this.$set(this.campaign, 'endtime', moment(val).add(7, 'days').format('YYYY-MM-DD'))
      this.$set(this.campaign, 'starttime', val)
    },
    changeEndTime(val) {
      this.$set(this.campaign, 'endtime', val)
    },
    changBudget(val) {
      this.$set(this.campaign, 'budget', val ? '' : 0)
    },
    changeBatch(val) {
      this.$set(this.campaign, 'range', val ? ['', ''] : undefined)
    },
    handleGame(meta) {
      this.campaign.gameId = meta.id
      this.campaign.appName = meta.name
      this.campaign.appUrl = meta.game_address
    },
    bindGetData(val) {
      if (val) {
        const date = formatDate(new Date(), 'MMdd')
        const time = formatDate(new Date(), 'hh:mm')
        this.campaign.campaignFeedName = `应用推广_${date}_${time}`
      } else {
        this.batch = false
        this.budgetMode = 0
        this.timeType = 'NONE'
        this.timeRange = 'NONE'
        this.campaign = {
          account_ids: [],
          subject: 2,
          campaignType: 1,
          campaignFeedName: '',
          bgtctltype: 1, // 标准
          bstype: 1,
          budget: 0,
          gameId: '', // !1
          appName: '',
          appUrl: '',
          pause: false,
          range: ['', '']
        }
      }
    },
    asyncSelect() {
      const [start_num, end_num] = this.campaign.range
      if (!this.campaign.account_ids.length) {
        this.$Message.error('投放账号不能为空！')
        return
      }
      if (!this.campaign.gameId && this.campaign.subject > 1) {
        this.$Message.error('推广游戏不能为空！')
        return
      }
      if (isEmpty(this.campaign.budget)) {
        this.$Message.error('推广计划预算不能为空！')
        return
      } else if (this.budgetMode && (this.campaign.budget < 50 || this.campaign.budget >= 10000000)) {
        this.$Message.error('推广计划预算范围：50-9,999,999.99数值！')
        return
      }
      if (this.timeType === 'CUSTOM' && (isEmpty(this.campaign.starttime) || isEmpty(this.campaign.endtime))) {
        this.$Message.error('推广日期不能为空！')
        return
      }
      if (this.timeRange === 'RANGE' && (!isArray(this.campaign.schedule) || !this.campaign.schedule.length)) {
        this.$Message.error('推广时段不能为空！')
        return
      }
      if (this.batch && (isEmpty(start_num) || isEmpty(end_num))) {
        this.$Message.error('批量区间数不能为空！')
        return
      }
      if (getByteLen(this.campaign.campaignFeedName) > 100) {
        this.$Message.error('推广计划名称不能多于100个字符！')
        return
      }
      const params = JSON.parse(JSON.stringify(this.campaign))
      this.$emit('on-batch', Object.assign(params, { start_num, end_num }))
    }
  },
  watch: {
    // 投放时间段
    weektimeData: {
      handler(nVal) {
        this.$set(this.campaign, 'schedule', this.getWeektime(nVal))
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.m-date-split {
  line-height: 32px;
  font-size: 16px;
  display: inline-block;
  padding: 0 8px;
}
</style>
